<template>
    <div class="pdetail_text_box">
        <!-- 标题 -->
        <div class="pdetail_text_name">{{goods.goods_name}}</div>
        <!-- 品牌 -->
        <div class="pdetail_text_brand">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.brand")}}</span>
            <!-- 内容 -->
            <span 
                class="pdetail_text_content"  
                v-popover:popover>
                {{goods.brand_name}}
            </span>
            <el-popover
                ref="popover"
                placement="top-start"
                trigger="hover"
                width="200"
                :disabled="!goods.brand_desc">
                <div>{{goods.brand_desc}}</div>
            </el-popover>
        </div>
        <hr>
        <!-- 商品编号 -->
        <div class="pdetail_text_code">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.goodsSn")}}</span>
            <!-- 内容 -->
            <span class="pdetail_text_content">{{goods.goods_sn}}</span>
        </div>
        <!-- 您的编号 -->
        <div class="pdetail_text_ucode" v-if="personal.personal_goodsid">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.personalSn")}}</span>
            <!-- 内容 -->
            <span class="pdetail_text_content">{{personal.personal_goodsid}}</span>
        </div>
        <hr>
        <!-- 价格 -->
        <template v-if="powerPrice && (!!personal.personal_price || show_price)">
            <div class="pdetail_text_price">
                <!-- 标题 -->
                <span class="pdetail_text_title">{{$t("message.pdetail.price")}}</span>
                <!-- 价格单位 -->
                <span class="pdetail_text_currency">{{currency}}</span>
                <!-- 内容 -->
                <span class="pdetail_text_content">{{actual_price}}</span>
                <!-- 商品单位 -->
                <span v-if="unit">/{{unit}}</span>
            </div>
            <hr>
        </template>
        <!-- 商品库存 -->
        <div class="pdetail_text_stock">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.stock")}}</span>
            <!-- 内容 -->
            <span class="pdetail_text_content">{{goods.goods_number}}</span>
        </div>
        <hr>
        <!-- 颜色分类 -->
        <div class="pdetail_text_color clearfix" v-if="!!color_attr && !(color_attr==false)">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.color")}}</span>
            <!-- 内容 -->
            <ul class="attr_content">
                <li v-for="(item,index) in color_attr"
                    :key="index"
                    :class="{selected_attr:selected_color==item.goods_attr_id}">
                    <a href="javascript:;"
                        @click="selectedColor(item.goods_attr_id,item.attr_price)">
                        {{item.attr_value}}
                    </a>
                </li>
            </ul>
        </div>
        <!-- 规格分类 -->
        <div class="pdetail_text_spec clearfix" v-if="!!spec_attr && !(spec_attr==false)">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.spec")}}</span>
            <!-- 内容 -->
            <ul class="attr_content">
                <li v-for="(item,index) in spec_attr"
                    :key="index"
                    :class="{selected_attr:selected_spec==item.goods_attr_id}">
                    <a href="javascript:;"
                        @click="selectedSpec(item)">
                        {{item.attr_value}}
                    </a>
                </li>
            </ul>
        </div>
        <!-- 订购数量 -->
        <div class="pdetail_text_num">
            <!-- 标题 -->
            <span class="pdetail_text_title">{{$t("message.pdetail.num")}}</span>
            <!-- 内容 -->
            <el-input-number
                v-model="num"
                :min="1"
                :max="parseInt(goods.goods_number)">
            </el-input-number>
            <span class="num-unit">/{{unit}}</span>
        </div>
        <hr>
        <!-- 加入按钮 -->
        <el-alert
            title="此商品已下架"
            type="info"
            center
            :closable="false"
            v-if="goods.is_on_sale == 1">
        </el-alert>
        <div class="pdetail_text_add"
            v-else>
            <!-- 加入购物车 -->
            <el-button
                type="primary"
                @click="addCart(true)"
                class="pdetail_text_btn"
                plain>
                <i class="glyphicon glyphicon-shopping-cart"></i>
                <span class="pdetail_text_btn_title">{{$t("message.pdetail.addcart")}}</span>
            </el-button>
            <!-- 加入报价车 -->
            <el-button
                type="primary"
                @click="addCart(false)"
                class="pdetail_text_btn"
                plain>
                <i class="glyphicon glyphicon-usd"></i>
                <span class="pdetail_text_btn_title">{{$t("message.pdetail.addqcart")}}</span>
            </el-button>
            <!-- 收藏 -->
            <el-button
				v-if="power.includes(17) || power.includes(0) || power.includes(111)"
                type="primary"
                @click="handleCollection"
                class="pdetail_text_btn"
                plain>
                <i class="glyphicon glyphicon-heart"></i>
                <!-- 未收藏 -->
                <span class="pdetail_text_btn_title"
                    v-if="!goods.collection>0">
                    {{$t("message.pdetail.collection1")}}
                </span>
                <!-- 已收藏 -->
                <span class="pdetail_text_btn_title"
                    v-else>
                    {{$t("message.pdetail.collection2")}}
                </span>
            </el-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    data() {
        return {
            // 计数器
            num: 1,
            // 颜色价格
            color_price: 0
        }
    },
    computed: {
        ...mapState({
            islogin: state => state.user.islogin,
            show_price: state => state.show_price,
            power: state => state.user.power,
            currency: state => state.currency,
            user_info: state => state.user.user_info,
            goods: state => state.goods.goods,
            personal: state => state.goods.personal,
            price: state => state.goods.price,
            unit: state => state.goods.unit,
            color_attr: state => state.goods.color_attr,
            spec_attr: state => state.goods.spec_attr,
            // 选中属性样式
            selected_spec: state => state.goods.selected_spec,
            selected_color: state => state.goods.selected_color,
            // 显示的实际价格
            actual_price(state){
                let p = Number(this.color_price) + Number(state.goods.price);
                return p.toFixed(2);
            }
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
    methods: {
        ...mapMutations([
            "setColor", // 写入选中颜色
            "setSpec", // 写入选中规格
            "setUnit", // 写入单位
            "setPrice",
            "changePdetailCollection" // 修改收藏状态
        ]),
        ...mapActions([
            "getAttrImg", // 修改属性
            "handleAddCart",
            "requestCollection",
        ]),
        selectedColor(id, price){ // 选中颜色属性
            this.getAttrImg(id); // 修改图片
            this.setColor(id); // 写入选中颜色
            this.color_price = price;
        },
        selectedSpec({goods_attr_id: id, attr_price: price, attr_value: unit}){ // 选中规格属性
            this.getAttrImg(id); // 修改图片
            this.setSpec(id); //写入选中规格
            this.setPrice(Number(price)); // 写入规格价格
            this.setUnit(unit); // 修改单位
        },
        addCart(arg){ // 加入预购
            if(this.islogin){
                let url = arg? "/index/detail/cart": "/index/detail/quote_cart";
                // 判断是否选中属性
                if(!(this.color_attr == false) && !this.selected_color){
                    this.$message({
                        message: this.$t("message.pdetail.colormsg"),
                        type: "warning",
                        center: true,
                    })
                    return
                }else if (!(this.spec_attr == false) && !this.selected_spec){
                    this.$message({
                        message: this.$t("message.pdetail.specmsg"),
                        type: "warning",
                        center: true,
                    })
                    return
                }

                let top_level = this.power.includes(0) || this.power.includes(111),
                cart_level = top_level || this.power.includes(7),
                qcart_level = top_level || this.power.includes(6);
                if(arg && !cart_level){ // 判断是否有下单权限
                    this.$message({
                        showClose: true,
                        message: this.$t("public.authorityQuote"),
                        type: "error"
                    })
                    return
                }
                if(!arg && !qcart_level){ // 判断是否有报价权限
                    this.$message({
                        showClose: true,
                        message: this.$t("public.authorityOrder"),
                        type: "error"
                    })
                    return
                }
                this.handleAddCart({
                    user_id: this.user_info.id,
                    goods_id: this.goods.goods_id,
                    goods_number: this.num,
                    goods_attr_id: this.selected_color,
                    goods_specification_id: this.selected_spec,
                    url
                }).then((res) => {
                    if(res.type == 1){
                        this.$message({
                            showClose: true,
                            message: this.$t("message.pdetail.addSucc"),
                            type: "success",
                            center: true
                        });
                    }else if(res.type == 2){
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: "error",
                            center: true
                        });
                    }else if(res.type == 5){
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: "error",
                            center: true
                        });
                    }
                })
            }else{
                this.$confirm(this.$t("public.notLogin"), {
                    confirmButtonText: this.$t("public.goLogin"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push('/login');
                }).catch(() => {});
            }
        },
        handleCollection(){ // 修改收藏状态
            if(this.islogin){
                let { goods_id, goods_sn, goods_name } = this.goods;
                this.requestCollection({
                    goods_id,
                    goods_sn,
                    goods_name
                }).then((res) => {
                    if(res == 1){
                        this.changePdetailCollection(1)
                        this.$message({
                            showClose: true,
                            message: this.$t("message.pdetail.collection3"),
                            type: 'success'
                        })
                    }else if(res == 3){
                        this.changePdetailCollection(0)
                        this.$message({
                            showClose: true,
                            message: this.$t("message.pdetail.collection4"),
                            type: 'success'
                        })
                    }
                })
            }else{
                this.$confirm(this.$t("public.notLogin"), {
                    confirmButtonText: this.$t("public.goLogin"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push('/login');
                }).catch(() => {});
            }
        }
    },
}
</script>

<style scoped>
/* 行公共属性 */
.pdetail_text_box>div{
    margin-bottom: 10px;
}
/* 商品名称 */
.pdetail_text_name{
    color: #333;
    font-size: 22px;
    font-weight: bold;
}
/* 商品标题 */
.pdetail_text_title{
    display: inline-block;
    width: 80px;
    color: #c0c4cc;
}
/* 价格标题 */
.pdetail_text_price>span{
    color: #ff6700
}
/* 价格单位 */
.pdetail_text_currency{
    font-size: 20px;
}
/* 价格 */
.pdetail_text_price>.pdetail_text_content{
    margin: 0 8px;
    font-size: 25px;
    font-weight: bold;
}
/* 属性标题 */
.pdetail_text_color>.pdetail_text_title,
.pdetail_text_spec>.pdetail_text_title{
    float: left;
}
/* 属性内容 */
.attr_content{
    margin-left: 80px;
}
.attr_content>li{
    float: left;
    margin: 0 10px 5px 0;
}
.attr_content>li>a{
    display: inline-block;
    padding: 10px 30px;
    background-color: #F2F6FC;
    border: 1px solid #E4E7ED;
    border-radius: 5px;
    color: #606266
}
/* 属性选中样式 */
.attr_content>li.selected_attr>a{
    background-color: #ff6700;
    color: #fff;
}
/* 添加按钮 */
.pdetail_text_btn{
    width: 150px;
    height: 50px;
}
/* 按钮内容 */
.pdetail_text_btn_title{
    margin-left: 5px;
    font-size: 16px;
}
/* 计数器旁价格单位 */
.num-unit{
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    font-size: 18px;
}
</style>